import React from 'react';
import logo from '../../res/images/neosvoc-logo.svg';
import TerminalMark from './TerminalMark';
import BrandingStyle from './BrandingStyle';

const Layout = ({branding, children, progress, alert, terminal}) => (
    <>
        {progress}
        {alert}
        {branding && <BrandingStyle {...branding} /> }

        <main role="main" className="container">
            <div className="main-logo">
                <img src={branding && branding.logo || logo} alt="NeosVoc" title="NeosVoc" />
            </div>
            <div className="row d-flex justify-content-center">
                <div className="box">
                    {terminal && <TerminalMark />}
                    {children}
                </div>
            </div>
        </main>
        {terminal &&
            <div id="app-footer">
                <a href="https://www.neosvoc.com/" target="_blank" rel="noreferrer">
                    <span>Powered by</span> <img src="/7fb672733ad0181ee22bb2ee6993b892.svg" alt="NeosVoc" title="NeosVoc" />
                </a>
            </div>}
    </>
);

export default Layout;
